let resumeData = {
    "name": "Mary Faynik",
    "role": "Senior Fullstack Engineer",
    "work_experience": [
      {
        "id": 0,
        "company": "Bond Vet",
        "position": "Staff Engineer",
        "start": "May, 2025",
        "end": "Present",
        "description": "Operate as a senior technical authority within the engineering org, contributing to sprint grooming, architectural decisions, and cross-team prioritization. Designed and currently maintain a production multi-channel AI customer service platform — architecting agent workflows and knowledge base, engineering GraphQL APIs to connect the AI agent to live operational data, and owning prompt engineering, flow design, and ongoing iteration. Mentor and manage engineers on the team, conduct design reviews, and manage CI/CD pipelines using CircleCI. Collaborate directly with product managers and business stakeholders to scope and deliver high-impact features end-to-end."
      },
      {
        "id": 1,
        "company": "Bond Vet",
        "position": "Senior Full-Stack Engineer",
        "start": "September, 2023",
        "end": "May, 2025",
        "description": "Influenced technical planning at the product and architecture level, serving as a key voice in engineering strategy and sprint execution. Led end-to-end implementation of client-facing messaging platforms, improving communication efficiency by 30%. Built reusable internal code libraries that accelerated feature delivery velocity across multiple product lines, and partnered closely with product managers and stakeholders to translate business requirements into well-scoped technical solutions."
      },
      {
        "id": 2,
        "company": "Bond Vet",
        "position": "Full-Stack Engineer",
        "start": "April, 2022",
        "end": "September, 2023",
        "description": "Built and shipped features across client-facing and internal applications using Node.js, GraphQL, React, and TypeScript, owning development from ticket to production. Developed internal reporting and analytics tooling to support operational and financial decision-making, and identified process improvements that increased team throughput and scoping accuracy."
      },
      {
        "id": 3,
        "company": "Milo",
        "position": "Fullstack Software Developer",
        "start": "February, 2020",
        "end": "March 2022",
        "description": "Developed software products to make veterinary healthcare workers happy. Created full-stack solutions for a quickly growing web app, with a focus on API integrations with third parties. Collaborated closely with the product team and end users to define, develop, execute, and troubleshoot features."
      },
      {
        "id": 4,
        "company": "Chelsea Piers",
        "position": "Project Manager, Corporate Planning",
        "start": "2019",
        "end": "2019",
        "description": "Managed an enterprise-wide multi-million dollar technology review and redesign including assessment of the user experience and web presence, financial reporting and back office software tools, and operational software used to run the businesses."
      },
      {
        "id": 5,
        "company": "Chelsea Piers Fitness",
        "position": "Regional Group Fitness Director",
        "start": "2018",
        "end": "2019",
        "description": "Managed all operations and logistical planning including scheduling, budgeting, and programming for Chelsea Piers' Group Fitness program across both club locations in Manhattan and Brooklyn, New York. Directly managed a team of 70+ instructors and three full-time employees with oversight of hiring and payroll processes. Assisted in the development and operations of Chelsea Piers' expansion into Brooklyn as a part of the organization's original management team."
      },
      {
        "id": 6,
        "company": "Bank of America Merrill Lynch",
        "position": "Trader - Analyst",
        "start": "2017",
        "end": "2018",
        "description": "Funded daily FX positions and supported senior traders in market-making, pricing, reporting, and risk management. Sector focus on FX and cross-currency basis swaps, interest rate swaps, and futures. Passed all requisite FINRA Series Licensing Exams (Series 7 and Series 63 certified)."
      },
      {
        "id": 7,
        "company": "United States Air Force",
        "position": "Associate Computer Scientist",
        "start": "2016",
        "end": "2017",
        "description": "Research and development in the areas of Command, Control, Communications, Computers, and Intelligence (C4I) to provide for the security, growth, and success of the Warfighter. Held a Top-Secret security clearance. Acted as a member of AFRL's in-house expansion research team. Processed and analyzed data to assist fundamentally in informed decision-making and increased awareness for DoD-wide operations."
      }
    ],
    "education": [
      {
        "id": 1,
        "university": "Yale University",
        "major": "Computer Science & Mathematics",
        "degree": "BS",
        "graduation": "2016"
      },
      { 
        "id": 2,
        "university": "Flatiron School",
        "major": "Web Development",
        "degree": "Bootcamp",
        "graduation": "2020"
      }
    ],
    "skills": {
      "tech": [ "React", "Ruby", "Rails", "NodeJS", "GraphQL", "JavaScript", "Typescript", "MongoDb", "PostgreSQL", "Heroku", "AWS", "S3", "Google Cloud", "Redis", "Github",  "SQL", "HTTP", "SOAP", "XML", "JSON", "C", "Java", "Python", "C++", "SQLite",  "CSS", "HTML", "MJML"],
      "interests": ["Fitness", "Running", "Cycling", "Rowing", "Marathon", "Triathlon", "Golf", "Cooking", "Knitting"]
    }
    }
  export default resumeData